import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'td-wb-nasdaq-basic-fine-print',
  templateUrl: 'nasdaq-basic-fine-print.component.html',
  imports: [
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NasdaqBasicFinePrintComponent {
  constructor() {}
}
